import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DoughnutChart, LoadingSpinner } from 'components';
import {
  Row,
  Col,
  Panel
} from 'react-bootstrap';

class CanvassingDoughnutCharts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      verified_data_chart_open: true,
      impacted_data_chart_open: true,
      initial_fetch_finished: false
    }
  }

  componentDidUpdate(prev_props) {
    if(
      prev_props.fetching &&
      !this.props.fetching &&
      !this.state.initial_fetch_finished
    ) {
      this.setState({ initial_fetch_finished: true });
    }
  }

  render() {
    const {
      chart_data: {
        verified_marker_data,
        impacted_marker_data
      },
      fetching
    } = this.props;

    return (
      <Row>
        <Col md={6} xs={12}>
          <div className='panel'>
            <div className='panel-heading'>
              <div className="panel-actions">
                <a
                  className="panel-action panel-action-toggle"
                  data-panel-toggle
                />
              </div>
              <h3 className='panel-title'>Verified Markers</h3>
            </div>
            <div className='panel-body' key='verified_marker_data'>
              {fetching && !this.state.initial_fetch_finished ? <LoadingSpinner /> : (
                verified_marker_data && verified_marker_data.length > 0 ? (
                  <div className='animated fadeInDown'>
                    <DoughnutChart
                      id='verified-markers-doughnut-chart'
                      data={verified_marker_data}
                      width={250}
                      height={250}
                      legend_placement='left'
                    />
                  </div>
                ) : (
                  <div className='animated fadeInDown'>
                    <h4><i>No verified markers in current date range</i></h4>
                  </div>
                )
              )}
            </div>
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div className='panel'>
            <div className='panel-heading'>
              <div className="panel-actions">
                <a
                  className="panel-action panel-action-toggle"
                  data-panel-toggle
                />
              </div>
              <h3 className='panel-title'>Impacted Markers</h3>
            </div>
            <div className='panel-body' key='impacted_marker_data'>
              {fetching && !this.state.initial_fetch_finished ? <LoadingSpinner /> : (
                impacted_marker_data && impacted_marker_data.length > 0 ? (
                  <div className='animated fadeInDown'>
                    <DoughnutChart
                      id='impacted-markers-doughnut-chart'
                      data={impacted_marker_data}
                      width={250}
                      height={250}
                      legend_placement='left'
                    />
                  </div>
                ) : (
                  <div className='animated fadeInDown'>
                    <h4><i>No impacted markers in current date range</i></h4>
                  </div>
                )
              )}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ canvassing }) => ({ canvassing });

export default connect(mapStateToProps)(CanvassingDoughnutCharts);



// WEBPACK FOOTER //
// ./src/browser/components/reports/canvassing/canvassing-doughnut-charts.js